export default {
  VALIDATIONS_FETCHED: 'VALIDATION_CUPOMS_FETCHED',
  VALIDATION_LOAD: 'VALIDATION_CUPOM_LOAD',
  VALIDATION_DETAIL: 'VALIDATION_CUPOM_DETAIL',
  VALIDATION_BUTTON_LOAD: 'VALIDATION_CUPOM_BUTTON_LOAD',
};
